import { render, staticRenderFns } from "./SignModal.vue?vue&type=template&id=0ffc9dc7&"
import script from "./SignModal.vue?vue&type=script&lang=ts&"
export * from "./SignModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports